<xemex-page-header
  [title]="companyName()"
  [loading]="companyStore.isLoading()"
  [breadcrumbs]="[
    { label: 'sidebarMenu.home' | translate, routerLink: '/' },
    { label: 'sidebarMenu.myCompany' | translate },
  ]"
  [withBackground]="true"
  [withTabBar]="true"
  [icon]="'apartment'"
>
  <xemex-tab-bar
    [tabs]="MY_COMPANY_TABS"
    [defaultTab]="0"
    (tabChange)="onTabChange($event)"
  ></xemex-tab-bar>
</xemex-page-header>

@if (selectedTab === 'general') {
  <xemex-page-body [scrollable]="true">
    <xemex-my-company-general-tab
      [companyDetail]="companyStore.myCompany()"
      [isLoading]="companyStore.isLoading()"
      [isSavingDefaultMeterRole]="companyStore.isSavingDefaultMeterRole()"
      [userRole]="userRole()"
      [isXemex]="isXemex()"
      (updateDefaultMeterRole)="onUpdateDefaultMeterRole($event)"
    ></xemex-my-company-general-tab>
  </xemex-page-body>
}

@if (selectedTab === 'users') {
  <xemex-page-body [scrollable]="false">
    <xemex-my-company-users-tab
      [users]="users"
      [permissions]="permissions()"
      [isLoading]="companyStore.isLoading()"
      (createUser)="onCreateUserClicked()"
      (editUser)="onEditUserClicked($event)"
      (deleteUser)="onDeleteUserClicked($event)"
      (resendInvite)="onResendInvite($event)"
      (userPageChange)="onUserPageChange($event)"
    ></xemex-my-company-users-tab>
  </xemex-page-body>
}
